module.exports = __webpack_public_path__ + "media/assets/img/flags/pt-PT-af1547fd2a4f0637b14c97b9a00037be.png";